var _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 71,
    viewBox: "0 0 76 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.7949,
    cy: 35.5241,
    rx: 37.7558,
    ry: 35.2571,
    fill: "#AB95FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.346 47.2763H27.7261C27.0585 47.2763 26.4183 47.0287 25.9462 46.5879C25.4742 46.1471 25.209 45.5493 25.209 44.9259V28.473",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3803 36.6998L48.7492 35.1767C48.1804 34.6456 47.409 34.3473 46.6046 34.3473C45.8003 34.3473 45.0288 34.6456 44.46 35.1767L36.5361 42.5758",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7953 33.1738C39.1855 33.1738 40.3124 32.1215 40.3124 30.8234C40.3124 29.5253 39.1855 28.473 37.7953 28.473C36.4052 28.473 35.2782 29.5253 35.2782 30.8234C35.2782 32.1215 36.4052 33.1738 37.7953 33.1738Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8635 23.772H32.7608C31.3706 23.772 30.2437 24.8243 30.2437 26.1224V40.2249C30.2437 41.523 31.3706 42.5753 32.7608 42.5753H47.8635C49.2537 42.5753 50.3806 41.523 50.3806 40.2249V26.1224C50.3806 24.8243 49.2537 23.772 47.8635 23.772Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDropIcon);
export default __webpack_public_path__ + "static/media/drag_drop_icon.a00a9936f1c07a0c4b7e4f2b8024323f.svg";
export { ForwardRef as ReactComponent };